import React, { useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import ContactForm from '../components/ContactForm';
import { getCategories } from '../api/woocommerce';

const IMG_HERO_BG = '/hero-bg.png';
const IMG_SECTION_BG = '/pattern-falcon.png';
const IMG_CANNA_HERO = '/falcon-build-to-last.png';
const IMG_FISHING_ACTION = '/falcon-mulinello.png';
const IMG_CONTACT_BG = '/sfondo-form.jpg';

const CATEGORIES_DATA = [
  { name: 'Bolognesi', img: '/cat-bolognesi.png', slug: 'bolognesi' },
  { name: 'Surf Casting', img: '/cat-surf-casting.png', slug: 'surf-casting' },
  { name: 'Spinning', img: '/cat-spinning.png', slug: 'spinning' },
  { name: 'Eging', img: '/cat-eging.png', slug: 'eging' },
  { name: 'Slow Pitch', img: '/cat-slow-pitch.png', slug: 'slow-pitch' },
  { name: 'Boat & Trolling', img: '/cat-boat-trolling.png', slug: 'boat-trolling' },
  { name: 'Line', img: '/cat-line.png', slug: 'line' },
  { name: 'Tools', img: '/cat-tools.jpg', slug: 'tools' },
];

export default function Homepage() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => { getCategories().catch(console.error); }, []);

  useEffect(() => {
    if (location.hash === '#contatti') {
      document.getElementById('contatti')?.scrollIntoView({ behavior: 'smooth' });
    }
  }, [location.hash]);

  return (
    <>
      <style>{`
        @keyframes ticker {
          from { transform: translateX(0); }
          to { transform: translateX(-50%); }
        }

        .hero { position: relative; height: 100vh; min-height: 800px; overflow: hidden; }
        .hero-bg { position: absolute; inset: 0; object-fit: cover; width: 100%; height: 100%; }
        .hero-overlay-dark { position: absolute; inset: 0; background: linear-gradient(to bottom, rgba(0,0,0,0.7) 0%, rgba(0,0,0,1) 18%, rgba(0,0,0,0.55) 35%, rgba(0,0,0,0.2) 45%, rgba(0,0,0,0) 52%); }
        .hero-overlay-red { position: absolute; inset: 0; background: linear-gradient(to bottom, rgba(215,25,33,0) 0%, rgba(215,25,33,0.2) 30%, rgba(215,25,33,0.55) 55%, rgba(215,25,33,1) 100%); }
        .hero-content { position: relative; z-index: 10; padding: 220px 138px 0; max-width: 820px; }
        .hero-title { font-family: 'Alumni Sans',sans-serif; font-weight: 500; font-size: 90px; line-height: 80px; color: #fff; margin: 0; }
        .hero-sub { font-family: 'Roboto',sans-serif; font-weight: 300; font-size: 18px; color: #fff; line-height: 1.5; max-width: 420px; margin: 0; }
        .hero-content-inner { display: flex; flex-direction: row; align-items: stretch; gap: 22px; }
        .hero-line { width: 2px; background: #d71921; flex-shrink: 0; }
        .hero-text { display: flex; flex-direction: column; gap: 36px; }
        .hero-scroll { position: absolute; bottom: 32px; left: 50%; transform: translateX(-50%); z-index: 10; display: flex; flex-direction: column; align-items: center; gap: 2px; }
        .hero-scroll-chev { width: 22px; height: 22px; border-right: 2px solid rgba(255,255,255,0.65); border-bottom: 2px solid rgba(255,255,255,0.65); transform: rotate(45deg); }

        .rs { background: #d71921; display: grid; grid-template-columns: 5fr 7fr; min-height: clamp(380px, 28vw, 480px); }
        .rs-left { padding: clamp(40px, 5vw, 80px) 50px clamp(40px, 5vw, 80px) clamp(80px, 8vw, 130px); display: flex; flex-direction: column; justify-content: center; }
        .rs-title { font-family: 'Alumni Sans',sans-serif; font-weight: 500; font-size: clamp(44px, 4.8vw, 72px); line-height: 1.05; color: #fff; margin: 0 0 40px 0; }
        .rs-p { font-family: 'Roboto',sans-serif; font-weight: 300; font-size: clamp(14px, 1.1vw, 16px); color: #fff; line-height: 1.65; margin: 0 0 10px 0; max-width: 490px; }
        .rs-p + .rs-p { margin-top: 14px; margin-bottom: 40px; }
        .rs-p b { font-weight: 500; }
        .rs-btn { display: inline-block; background: #fff; color: #d71921; font-family: 'Alumni Sans',sans-serif; font-weight: 600; font-size: 22px; padding: 12px 32px; cursor: pointer; border: none; align-self: flex-start; transition: opacity 0.2s; white-space: nowrap; }
        .rs-btn:hover { opacity: 0.85; }
        .rs-right { position: relative; overflow: hidden; }
        .rs-dark { position: absolute; right: 0; top: 0; width: 52%; height: 100%; background: #0d0000; }
        .rs-pattern { position: absolute; right: 0; top: 0; width: 52%; height: 100%; object-fit: cover; object-position: left center; }
        .rs-overlay { position: absolute; inset: 0; background: linear-gradient(to right, #d71921 0%, #d71921 48%, rgba(215,25,33,0.82) 62%, rgba(215,25,33,0.4) 78%, transparent 95%); z-index: 1; pointer-events: none; }
        .rs-falcon { position: absolute; top: 0; left: 38%; transform: translateX(-50%); height: 92%; width: auto; max-width: none; z-index: 2; }

        .black-section { --dt: 64%; --db: 51%; background: #000; position: relative; overflow: hidden; min-height: clamp(460px, 43vw, 620px); display: flex; align-items: center; justify-content: flex-end; }
        .black-bg { position: absolute; left: 0; top: 0; width: 64%; height: 100%; object-fit: cover; object-position: center 70%; opacity: 0.85; }
        .black-cover { position: absolute; inset: 0; background: #000; z-index: 1; clip-path: polygon(calc(var(--dt) - 8px) 0%, 100% 0%, 100% 100%, calc(var(--db) - 8px) 100%); }
        .black-diag { position: absolute; inset: 0; z-index: 2; pointer-events: none; background: #d71921; clip-path: polygon(calc(var(--dt) - 8px) 0%, calc(var(--dt) + 8px) 0%, calc(var(--db) + 8px) 100%, calc(var(--db) - 8px) 100%); }
        .black-content { position: relative; z-index: 4; padding: 80px 50px 80px 40px; max-width: 620px; width: 46%; margin-right: 1%; }
        .black-title { font-family: 'Alumni Sans',sans-serif; font-weight: 500; font-size: 72px; line-height: 64px; color: #fff; margin-bottom: 36px; }
        .product-item { margin-bottom: 24px; padding-left: 28px; position: relative; }
        .product-item-dot { position: absolute; left: 0; top: 8px; width: 24px; height: 24px; background: url('/falcon-symbol.png') no-repeat center center; background-size: contain; }
        .product-item-title { font-family: 'Alumni Sans',sans-serif; font-weight: 500; font-size: 24px; color: #fff; margin-bottom: 4px; }
        .product-item-text { font-family: 'Roboto',sans-serif; font-weight: 300; font-size: 15px; color: rgba(255,255,255,0.8); line-height: 1.5; }
        .black-btn { display: block; background: #d71921; color: #fff; font-family: 'Alumni Sans',sans-serif; font-weight: 600; font-size: 19px; padding: 12px 28px; margin-top: 28px; cursor: pointer; border: none; transition: opacity 0.2s; }
        .black-btn:hover { opacity: 0.85; }

        .ticker { background: #181818; overflow: hidden; white-space: nowrap; }
        .ticker-inner { display: inline-flex; animation: ticker 22s linear infinite; padding: 14px 0; }
        .ticker-item { font-family: 'Alumni Sans',sans-serif; font-weight: 500; font-size: 28px; color: rgba(255,255,255,0.5); padding: 0 24px; display: flex; align-items: center; gap: 10px; }
        .ticker-arrow { width: 18px; height: 18px; display: inline-block; background: url('/falcon-symbol.png') no-repeat center center; background-size: contain; }

        .cat-section { background: #000; }
        .cat-grid-5 { display: grid; grid-template-columns: repeat(5, 1fr); }
        .cat-grid-3 { display: grid; grid-template-columns: repeat(3, 1fr); }
        .cat-card { position: relative; height: 440px; overflow: hidden; cursor: pointer; border-right: 1px solid rgba(255,255,255,0.08); }
        .cat-card-3 { position: relative; height: 280px; overflow: hidden; cursor: pointer; border-right: 1px solid rgba(255,255,255,0.08); }
        .cat-card img, .cat-card-3 img { width: 100%; height: 100%; object-fit: cover; transition: transform 0.4s; }
        .cat-card:hover img, .cat-card-3:hover img { transform: scale(1.06); }
        .cat-overlay { position: absolute; inset: 0; background: linear-gradient(to bottom, rgba(0,0,0,0.1), #000); }
        .cat-label { position: absolute; bottom: 56px; left: 16px; font-family: 'Alumni Sans',sans-serif; font-weight: 500; font-size: 30px; color: #fff; line-height: 28px; }
        .cat-btn { position: absolute; bottom: 10px; left: 16px; background: #d71921; color: #fff; font-family: 'Alumni Sans',sans-serif; font-weight: 600; font-size: 16px; padding: 7px 18px; cursor: pointer; border: none; }
        .big-cta { text-align: center; padding: 36px; background: #000; }
        .big-cta-btn { background: #d71921; color: #fff; font-family: 'Alumni Sans',sans-serif; font-weight: 600; font-size: 20px; padding: 14px 36px; cursor: pointer; border: none; transition: opacity 0.2s; }
        .big-cta-btn:hover { opacity: 0.85; }

        @media (max-width: 1500px) {
          .hero-content { padding: 206px 100px 0; }
        }
        @media (max-width: 1700px) {
          .black-section { flex-direction: row; justify-content: center; min-height: 480px; }
          .black-bg { position: absolute; left: 0; top: 0; width: 100%; height: 100%; object-fit: cover; object-position: center center; opacity: 0.3; }
          .black-cover { clip-path: none; background: linear-gradient(to left, #000 0%, #000 20%, rgba(0,0,0,0.3) 50%, transparent 75%); }
          .black-diag { display: none; }
          .black-content { width: 100%; max-width: 700px; padding: 60px 48px; }
          .black-title { font-size: 60px; line-height: 54px; }
        }
        @media (max-width: 1300px) {
          .hero-content { padding: 184px 80px 0; }
        }
        @media (max-width: 1100px) {
          .hero-content { padding: 160px 60px 0; }
          .hero-title { font-size: 76px; line-height: 68px; }
          .rs { grid-template-columns: 1fr 1fr; }
          .rs-falcon { left: 45%; }
          .black-title { font-size: 48px; line-height: 44px; }
          .cat-card { height: 320px; }
          .cat-card-3 { height: 220px; }
        }
        @media (max-width: 900px) {
          .hero-content { padding: 150px 28px 0; }
          .hero-title { font-size: 60px; line-height: 54px; }
          .hero-sub { font-size: 16px; }
          .rs { grid-template-columns: 1fr; min-height: auto; }
          .rs-left { padding: 52px 28px 48px 28px; }
          .rs-right { height: 300px; }
          .rs-falcon { left: 50%; height: 100%; }
          .rs-pattern { width: 65%; }
          .black-content { padding: 40px 28px 52px; }
          .black-title { font-size: 52px; line-height: 46px; }
          .cat-grid-5 { grid-template-columns: repeat(2, 1fr); }
          .cat-grid-3 { grid-template-columns: repeat(2, 1fr); }
          .cat-card { height: 260px; }
          .cat-card-3 { height: 200px; }
          .cat-label { font-size: 24px; }
        }
        @media (max-width: 500px) {
          .hero-title { font-size: 48px; line-height: 44px; }
          .rs-title { font-size: 40px; line-height: 1.05; }
          .black-title { font-size: 40px; line-height: 36px; }
          .cat-grid-5 { grid-template-columns: 1fr 1fr; }
          .cat-grid-3 { grid-template-columns: 1fr; }
          .cat-card { height: 220px; }
          .ticker-item { font-size: 20px; }
        }
      `}</style>

      <section className="hero">
        <img src={IMG_HERO_BG} alt="" className="hero-bg" />
        <div className="hero-overlay-dark" />
        <div className="hero-overlay-red" />
        <Navbar />
        <div className="hero-content">
          <div className="hero-content-inner">
            <div className="hero-line" />
            <div className="hero-text">
              <h1 className="hero-title">Crafted<br />through<br />experience.</h1>
              <p className="hero-sub">Punto di riferimento per un pubblico di pescatori esigenti e appassionati per diverse discipline della pesca, su tutte la "Bolognese".</p>
            </div>
          </div>
        </div>
        <div className="hero-scroll">
          <div className="hero-scroll-chev" />
          <div className="hero-scroll-chev" />
        </div>
      </section>


      <section className="rs">
        <div className="rs-left">
          <h2 className="rs-title">Progettati<br />per durare</h2>
          <p className="rs-p">Grazie a oltre quarant'anni di esperienza nel mondo della pesca sportiva,</p>
          <p className="rs-p">Falcon progetta e sviluppa <b>attrezzature affidabili e performanti</b> pensate per accompagnare il pescatore in ogni uscita. Mettiamo al centro la qualità dei materiali, la ricerca continua e il know-how tecnico per <b>offrire monofili e canne da pesca</b> che uniscono tradizione e innovazione, garantendo prestazioni costanti nel tempo.</p>
          <Link to="/categorie"><button className="rs-btn">Scopri i prodotti</button></Link>
        </div>
        <div className="rs-right">
          <div className="rs-dark" />
          <img src={IMG_SECTION_BG} alt="" className="rs-pattern" />
          <div className="rs-overlay" />
          <img src={IMG_CANNA_HERO} alt="Falcon" className="rs-falcon" />
        </div>
      </section>

      <section className="black-section">
        <img src={IMG_FISHING_ACTION} alt="" className="black-bg" />
        <div className="black-cover" />
        <div className="black-diag" />
        <div className="black-content">
          <h2 className="black-title">I nostri<br />prodotti</h2>
          {[
            { t: 'Canne da pesca', d: 'Per ogni situazione di pesca, per ogni stile e preda, Falcon ha la canna adatta a te.' },
            { t: 'Line', d: 'Falcon con i suoi 30 anni di esperienza e la vasta gamma di fili è la scelta per il meglio!' },
            { t: 'Accessori', d: 'Linea di foderi che garantiscono il massimo della protezione alle vostre canne Falcon.' },
          ].map(item => (
            <div key={item.t} className="product-item">
              <div className="product-item-dot" />
              <p className="product-item-title">{item.t}</p>
              <p className="product-item-text">{item.d}</p>
            </div>
          ))}
          <Link to="/categorie"><button className="black-btn">Scopri le nostre categorie di prodotti</button></Link>
        </div>
      </section>

      <div className="ticker">
        <div className="ticker-inner">
          {Array(4).fill([
            {label:'Canne da pesca', slug:'canne-da-pesca'},
            {label:'Line', slug:'line'},
            {label:'Accessori per la pesca', slug:'tools'},
          ]).flat().map((t,i) => (
            <Link key={i} to={`/categoria/${t.slug}`} className="ticker-item" style={{textDecoration:'none',color:'inherit'}}>{t.label}<span className="ticker-arrow" /></Link>
          ))}
        </div>
      </div>

      <section className="cat-section">
        <div className="cat-grid-5">
          {CATEGORIES_DATA.slice(0,5).map(cat => (
            <div key={cat.name} className="cat-card" onClick={() => navigate(`/categoria/${cat.slug}`)}>
              <img src={cat.img} alt={cat.name} />
              <div className="cat-overlay" />
              <span className="cat-label">{cat.name}</span>
              <button className="cat-btn">Scopri di più</button>
            </div>
          ))}
        </div>
        <div className="cat-grid-3">
          {CATEGORIES_DATA.slice(5).map(cat => (
            <div key={cat.name} className="cat-card-3" onClick={() => navigate(`/categoria/${cat.slug}`)}>
              <img src={cat.img} alt={cat.name} />
              <div className="cat-overlay" />
              <span className="cat-label">{cat.name}</span>
              <button className="cat-btn">Scopri di più</button>
            </div>
          ))}
        </div>
        <div className="big-cta">
          <Link to="/categorie"><button className="big-cta-btn">Scopri le nostre categorie di prodotti</button></Link>
        </div>
      </section>

      <ContactForm title={'Compila\nil form'} bgImage={IMG_CONTACT_BG} />
      <Footer />
    </>
  );
}
